import type { TrackingEvent } from '../../../Entities/Schema.entity';
import { cmpVisibleSchema } from './CmpVisibleSchema';

export const cmpVisibleToEvent = (): TrackingEvent => ({
  schema: cmpVisibleSchema.ref,
  data: {},
});
